import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.01,
  
  denyUrls: [
    // Ignore errors from bootstrap.min.js
    /bootstrap\.min\.js$/,
    // Add more URLs or file patterns to ignore
  ],
  ignoreErrors: [
    // Ignore specific error messages
    '$("#disclaimer").modal is not a function',
    'bootstrap.min.js',
    '$ is not defined',
    'Could not load "util"',
    't is not a function',
    't.map is not a function',
    "'t' is undefined",
    "$(...).modal is not a function"
    // Add more error messages or patterns to ignore
  ],
  beforeSend(event) {
    if (navigator.connection?.effectiveType === "2g") return null;
    return event;
  },
 
 
});
